import { Router } from '@angular/router';

/**
 * URL de un módulo del grupo Apps según el panel activo (empresa o sistema), para resolver permisos.
 * Debe coincidir con `Wave10ModuleUrls.*_TENANT` / `*_SYSTEM` del backend (p. ej. `/apps/whatsapp`).
 */
export function resolveAppsModuleUrl(router: Router, segment: string): string {
  const prefix = router.url.split('/').filter(Boolean)[0] ?? 'apps';
  const base = prefix === 'apps-sistema' ? '/apps-sistema' : '/apps';
  return `${base}/${segment}`;
}
